export default "__VITE_ASSET__6t_gUGEF__"